import { OLDEST_DATE } from 'constants/defaultConstants';
import { getLastOperationDate } from '../api/getLastOperationDate';

export const getOperationDate = async (societyId: string) => {
  const lastOperationDate = await getLastOperationDate(societyId);

  if (!lastOperationDate) {
    return OLDEST_DATE;
  }

  const date = new Date(lastOperationDate as string);
  date.setMinutes(date.getMinutes() + 1);

  return date;
};
